export default {
  RENTAL_MANAGER: 'rental-manager-app',
  RENTER_HUB: 'renter-hub-app',
  DEV_SERVER: 'dev-server-app',
};

// Base path each app is mounted at. Single source of truth shared by the
// express route mounts (server) and the isomorphic <AppRoutes> switch.
export const BASE_PATHS = {
  RENTAL_MANAGER: '/rental-manager/payments',
  RENTER_HUB: '/renter-hub/payments',
  DEV_SERVER: '/',
} as const;
